import Customers from "../components/Customers/Customers";
import {PERM} from "../utilites/permissions";

const customers = [
  {
    path: '/customers/:id(\\d+)?',
    name: 'Customers',
    component: Customers,
    meta: {
      requiresAuth: true,
      permissions: [
        PERM.CUSTOMER,
      ]
    },
  },
];

export default customers;



// WEBPACK FOOTER //
// ./src/router/customers.js